import React from 'react';
import styled from '@emotion/styled';
import { Color, MAX_WIDTH, Radius } from 'views/constants';
import { Spacer } from 'views/components/atoms/Spacer';

type ImageType = {
  srcElement: React.ReactNode;
  width: string;
};

interface WrapperProps {
  backgroundColor?: Color;
}

interface ImageWrapperProps {
  image: ImageType;
}

const Wrapper = styled.div<WrapperProps>`
  background-color: ${({ backgroundColor }): string =>
    backgroundColor || Color.C6};
  border-color: ${Color.C14};
  border-width: ${'1px'};
  border-radius: ${Radius.DEFAULT};
  border-style: solid;
  padding: 16px;
  text-align: center;

  max-width: ${MAX_WIDTH};
  margin: auto;
`;

const ImageWrapper = styled.div<ImageWrapperProps>`
  margin: auto;
  width: ${({ image }): string => image.width};
`;

interface PanelProps {
  text: React.ReactNode;
  title?: React.ReactNode;
  image?: ImageType;
  backgroundColor?: Color;
}

export const Panel: React.FC<PanelProps> = ({
  text,
  title,
  image,
  backgroundColor,
}) => {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      {title ? (
        <>
          {title}
          <Spacer />
        </>
      ) : null}
      {image ? (
        <>
          <ImageWrapper image={image}>{image.srcElement}</ImageWrapper>
          <Spacer />
        </>
      ) : null}
      {text}
    </Wrapper>
  );
};
